export default "/images/mydev-hover-dark.svg?89c0774a328743f660a7f7393ba5f542";